<div class="login-page">
  <form (ngSubmit)="login()">
    <mat-card class="login-card shadow-1">

      <!-- Adding a width and a height will ensure that the image displays properly across browsers (fixes a problem with IE) -->
      <img src="./assets/DRC-INSIGHT-blk.svg" width="142" height="44">

      @if (loginFailed) {
        <mat-label class="login-failed">Username or Password incorrect</mat-label>
      }

      <mat-form-field id="loginEmailFormField">
        <mat-label id="loginEmailLabel">Username</mat-label>
        <input matInput [(ngModel)]="userEmail" name="userEmail" required>
      </mat-form-field>

      <mat-form-field id="loginPasswordFormField">
        <mat-label>Password</mat-label>
        <input matInput [type]="passInputType" [(ngModel)]="userPassword" name="userPassword" required>
        <div [hidden]="!capslock" class="caps-lock-tooltip subtitle-2">Caps Lock is on</div>
      </mat-form-field>

      <div class="portal-unavailable-section">
        <mat-checkbox (click)="togglePortalLogin()" class="portal-checkbox">
          Portal Unavailable
        </mat-checkbox>
        <div class="portal-help-text">
          Use this option if the DRC INSIGHT Portal and/or Security Service are unavailable.
        </div>
      </div>

      <button mat-raised-button type="submit" color="primary">Sign In</button>

    </mat-card>
  </form>
</div>
